import React, {useEffect, useState} from "react";
import {usePatientDetails} from "../../DoctorsModule/ReferralNote/usePatientDetails";
import {usePreviousFindings} from "../../MedicationandVisits/Findings/hooks/usePreviousFindings";
import ObGynSidebar from "../Utils/ObGynSidebar";
import Label, {FormLabel} from "../../Utils/FormInputs/Label";
import {ResizableTextarea} from "../../Utils/FormInputs/Textarea";
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import ObGynPatientInfo from "../Utils/ObGynPatientInfo";
import {RightAlignedContainer} from "../../Utils/styledComponents";
import {
    Button,
    PatientNotesContainer,
    SavedNotesContainer,
    StyledAdd
} from "../../DoctorsModule/Notes/PatientNotesContainer";
import {LoadingGif} from "../../Utils/Loader";
import {
    ActionParagraph,
    NotesRow,
    NotFound,
    PreviousNotesTable,
    StyledImage
} from "../../DoctorsModule/Notes/PreviousNotesTable";
import {splitNotes} from "../../Radiology/RadiologyReport";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import {
    FormGroup,
    HistoryGroup,
    Paragraph,
    Radio,
    SaveNotesForm
} from "../../MedicationandVisits/Findings/PatientFindings";
import {connect} from "react-redux";


const headData = [{name:'Date'},{name:'Written By'}]
const ClinicalNotes = ({actions, snackbars, match}) => {
    const {patient_number, visit_id, patient_type} = match.params;



    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

    const {previousFindings,  handleUpdateNotes, isLoading, isError,submittedNotes,
        isPendingEdit, handleEdit, handleCancelEdit, handleChangeNotes,
        isSuccess, handleOpen, addNotesProps, isAddResolved} = usePreviousFindings(actions,visit_id, patient_type,patient_number)

    const {openBar, type, message} = snackbars;

    const {openAddNotes,  handleOpenNotesInput} = addNotesProps


    // get the doctor's name
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;


    const containerHeading = {
        '1':'Clinical Notes',
        '2' : 'Findings'
    }
    const {isPending, handleCloseNotesInput,diseases, handleChangeDisease, submitted, handleChangeState, examNotes} = addNotesProps
    const {other_diseases, allergy, allergies} = examNotes

    const diseaseComponent = (
        <HistoryGroup>
            <Paragraph><strong>Chronic Illnesses</strong></Paragraph>
            {diseases.map((item, index)=>(
                <Radio
                    key={index}
                    label={item.disease}
                    onChange={(e)=>handleChangeDisease(e, index)}
                    type="checkbox"
                    name={item.name}
                    checked={item[item.name]}
                />
            ))}
            <FormGroup>
                <FormLabel  name='Others(specify)' toolTip='Write other previous illnesses'/>
                <ResizableTextarea rows='0'  name='other_diseases' value={other_diseases} onChange={handleChangeState} placeholder='Write other illnesses.....'/>
            </FormGroup>
        </HistoryGroup>
    )

    const allergyComponent = (
        <HistoryGroup>
            <Paragraph>Allergies</Paragraph>
            <Radio
                inline
                checked={allergy === 'Yes'}
                label="Yes"
                value="Yes"
                name="allergy"
                onChange={handleChangeState}
                type="radio"
            />
            <Radio
                inline
                checked={allergy === 'No'}
                label="No"
                value="No"
                name="allergy"
                onChange={handleChangeState}
                type="radio"
            />
            {allergy === 'Yes' ?  <ResizableTextarea   rows='0' submitted={submitted} value={allergies} name='allergies'
                                                       onChange={handleChangeState} placeholder='Write other allergies.....'/>:null}
        </HistoryGroup>
    )
    return (
        <div className='journals'>
            <PageTitle title="Clinical Notes"/>
            <SubHeader
                title="Doctor"
                subTitle="Clinical Notes"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
            <ObGynSidebar
                patient_number={patient_number}
                visit_id={visit_id}
                patient_type={patient_type}
            >
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                {openAddNotes ?  <SaveNotesForm {...{...addNotesProps, allergyComponent, diseaseComponent}}>
                    <RightAlignedContainer>
                        <button type="submit" disabled={isPending}
                                className="btn sms-btn btn-sm mt-5 mr-3">{isPending ? "Saving" : "Save Notes"}</button>
                        <button type='button' onClick={handleCloseNotesInput} className="btn sms-gray-btn btn-sm  mt-5">Cancel</button>
                    </RightAlignedContainer>
                </SaveNotesForm> : null}
                <div style={{marginLeft:'20px', marginRight:'20px'}}>
                    <PatientNotesContainer heading={containerHeading[patient_type]} button={
                        previousFindings.length > 0 ? <RightAlignedContainer>
                            <Button onClick={handleOpenNotesInput}><StyledAdd/>Add</Button>
                        </RightAlignedContainer>: null}>
                        {isLoading ? <LoadingGif/> : null}
                        {isSuccess && previousFindings.length > 0 ?
                            <PreviousNotesTable headData={headData}>
                                {previousFindings.map(item=>{
                                    const examNotes = {
                                        physical_examination:item.physical_examination, past_medical_history:item.past_medical_history, past_obstetric_history:item.past_obstetric_history,
                                        family_history:item.family_history, notes:item.notes, complaints:item.complaints
                                    }

                                    const updateForm = (
                                        <>
                                            <SaveNotesForm submitted={submittedNotes} handleSubmit={(e)=>handleUpdateNotes(e, item)}
                                                           handleChangeState={(e)=>handleChangeNotes(e, item.id)}
                                                           examNotes={examNotes} isEdit>
                                                <button type="submit" disabled={isPendingEdit}
                                                        className="btn sms-btn small-btn btn-sm mt-2 mr-3">{isPendingEdit ? "Saving...." : "Update"}</button>
                                                <button type='button' onClick={()=>handleCancelEdit(item.id)} className="btn sms-gray-btn small-btn  btn-sm mt-2">Cancel</button>

                                            </SaveNotesForm>
                                        </>

                                    )
                                    const viewNotes = (
                                        <div className='row mb-0'>
                                            <div className='col-lg-6'>
                                                {item.complaints ? <>
                                                    <Label name='Presenting Complaints'/>
                                                    <SavedNotesContainer data-testid="complaints">
                                                        {splitNotes(item.complaints)}
                                                    </SavedNotesContainer>
                                                </>: null}
                                                {item.past_medical_history ? <>
                                                    <Label name='Past medical history'/>
                                                    <SavedNotesContainer data-testid="medical_history">
                                                        {splitNotes(item.past_medical_history)}
                                                    </SavedNotesContainer>
                                                </>: null}
                                                {item.physical_examination ?
                                                    <>
                                                        <Label name='Physical examination'/>
                                                        <SavedNotesContainer data-testid="p_examination">
                                                            {splitNotes(item.physical_examination)}
                                                        </SavedNotesContainer>
                                                    </>: null}



                                            </div>
                                            <div className='col-lg-6'>
                                                {item.past_obstetric_history ? <>
                                                    <Label name='Past obstetric history'/>
                                                    <SavedNotesContainer data-testid="obs_history">
                                                        {splitNotes(item.past_obstetric_history)}
                                                    </SavedNotesContainer>
                                                </>: null}
                                                {item.family_history ? <>
                                                    <Label name='Family history'/>
                                                    <SavedNotesContainer data-testid="f_history">
                                                        {splitNotes(item.family_history)}
                                                    </SavedNotesContainer>
                                                </>: null}

                                                {item.notes ? <>
                                                    <Label name='Notes'/>
                                                    <SavedNotesContainer data-testid="clinical_notes">
                                                        {splitNotes(item.notes)}
                                                    </SavedNotesContainer>
                                                </>: null}

                                            </div>
                                        </div>
                                    )
                                    return(
                                        <NotesRow open={item.open} date={item.date} handleOpen={()=>handleOpen(item.id)}
                                                  person={item.doctor_name} colSpan={headData.length}>
                                            {!item.displayInput ?
                                                <>
                                                    {viewNotes}
                                                    {item.isEdit ? <button className='btn-sm btn small-btn sms-info-btn' onClick={()=>handleEdit(item.id)}>Edit notes</button> : null}
                                                </>
                                                :null}
                                            {item.displayInput ? updateForm : null}
                                        </NotesRow>
                                    )})}
                            </PreviousNotesTable>:null}
                        {isSuccess &&  previousFindings.length === 0 && !openAddNotes ?
                            <NotFound text='There are no clinical notes to display for this patient' image={(
                                <StyledImage src="/images/examination.png" alt="clipboard"/>
                            )}>
                                <ActionParagraph id="record_notes" onClick={handleOpenNotesInput}>Record notes</ActionParagraph>
                            </NotFound>:null}
                        {isError ? <p>The server did not return a valid response</p>:null}
                    </PatientNotesContainer>
                </div>
            </ObGynSidebar>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClinicalNotes);